import { TrendingUp } from "lucide-react";

const PaymentManagementTrendChart = () => {
  return (
    <div className="rounded-2xl border border-border/60 bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md lg:col-span-2">
      {/* Header */}
      <div className="flex flex-col space-y-1.5 p-6 pb-2">
        <h3 className="flex items-center gap-2 text-base font-bold tracking-tight text-foreground">
          <TrendingUp className="h-4 w-4 text-primary" />
          Monthly Collection Trend
        </h3>
      </div>

      {/* Chart */}
      <div className="p-6 pt-0">
        <div className="h-56">
          {/* Insert Recharts Component Here */}
          {/* <YourReChart /> */}
        </div>
      </div>
    </div>
  );
};

export default PaymentManagementTrendChart;
